import { useState } from "react";
import { photoAlbum } from "../data/scenes";

export default function PhotoAlbumViewer() {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div
      style={{
        width: "100%",
        height: "100dvh",
        background: "#000",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >


      {/* 🎮 Controls */}
      <div
        style={{
          position: "absolute",
          bottom: 25,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 20,
          background: "rgba(0,0,0,0.6)",
          padding: "10px 20px",
          borderRadius: 30,
          backdropFilter: "blur(6px)",
        }}
      >
        <button onClick={() =>
          setSelectedIndex((prev) =>
            prev === 0
              ? photoAlbum.length - 1
              : prev - 1
          )
        } style={btnStyle}>
          ‹
        </button>

        <button onClick={() =>
          setSelectedIndex((prev) =>
            prev === photoAlbum.length - 1
              ? 0
              : prev + 1
          )
        } style={btnStyle}>
          ›
        </button>
      </div>

      {/* Image */}
      <img
        src={photoAlbum[selectedIndex]}
        alt=""
        style={{
          maxWidth: "95%",
          maxHeight: "90%",
          objectFit: "contain",
        }}
      />

    </div>
  );
}

const btnStyle = {
  width: 45,
  height: 45,
  fontSize: 26,
  borderRadius: "50%",
  border: "1px solid #fff",
  background: "rgba(0,0,0,0.6)",
  color: "#fff",
  cursor: "pointer",
};